var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-options dropdown" },
    [
      _vm._l(_vm.iterable, function(option, index) {
        return _c(
          "a",
          {
            key: index,
            staticClass: "option u-row",
            on: {
              click: function($event) {
                return _vm.update(option)
              }
            }
          },
          [_vm._v(_vm._s(option))]
        )
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }